module.exports = __webpack_public_path__ + "static/img/hot.4ad75bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/hot.png
// module id = brXd
// module chunks = 2